import { FormControlWithStatus } from 'components/Form/FormControlVerificationStatus';
import { IDriverCdlFields } from 'common/document/ui/driver-document';
import { DatePickerWithStatus } from 'components/Form/FormControlVerificationStatus/DatePicker';
import { IFieldPolygon } from '../Utils/field-polygon';
import { IFieldVerificationResult } from '../Utils/verification-result';
import { shouldHideVerificationByStatus } from '../Utils/verification-status';

type InputProps = {
  getFieldErrorProp: (field: keyof IDriverCdlFields) => {
    error: string | undefined;
  };
  getFieldProps: (field: keyof IDriverCdlFields) => {
    name: keyof IDriverCdlFields;
    value: any;
    onChange: (inputValue: any) => void;
  };
  fieldVerified: { [key: string]: boolean };
  fieldPolygon: IFieldPolygon;
  verificationResult?: IFieldVerificationResult;
  verificationStatus?: any;
  onHoverField?: (polygon: any | null) => void;
  onUnHoverField?: () => void;
  disabled?: boolean;
};

export const GenericFormShort = ({
  getFieldProps,
  fieldVerified,
  fieldPolygon,
  verificationResult,
  onHoverField,
  onUnHoverField,
  verificationStatus,
  disabled = false,
}: InputProps) => {
  const handleHoverField = (data: any) => {
    onHoverField && onHoverField(data);
  };

  const handleUnHoverField = () => {
    onUnHoverField && onUnHoverField();
  };

  return (
    <form>
      <FormControlWithStatus id="Issue Date *" disabled={disabled}>
        <DatePickerWithStatus
          label="Issue Date *"
          {...getFieldProps('issueDate')}
          verified={fieldVerified['issueDate']}
          verificationResult={
            verificationResult ? verificationResult['issueDate'] : undefined
          }
          disabled={disabled}
          hideVerification={shouldHideVerificationByStatus(
            verificationStatus,
            'issueDate'
          )}
          onMouseEnter={() => handleHoverField(fieldPolygon['issueDate'])}
          onMouseLeave={handleUnHoverField}
        />
      </FormControlWithStatus>
    </form>
  );
};
